import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { setNavigate } from 'helpers/navigation';
import WrapperItems from 'components/WrappedItems';
import ViewTokenAuthentication from 'components/views/public/token/component';
import ViewLogin from 'components/views/public/login/component';
import ViewGames from 'components/views/admin/games/component';
import ViewFacilitatorNewGame from 'components/views/facilitator/newGame/component';
import ViewSingleTemplate from 'components/views/admin/templates/single/component';
import ViewTemplateListing from 'components/views/admin/templates/listing/component';
import ViewAdminUsers from 'components/views/admin/users/component';
import ViewAdminDashboard from 'components/views/admin/dashboard/component';
import ViewSingleTemplateTaskEdit from 'components/views/admin/templates/single/tasks/single/component';
import ViewApiAuthentication from 'components/views/public/api/component';
import ViewURLAuthentication from 'components/views/public/url/component';
import { AuthRoute } from 'components/routers/AuthRoute';
import { USER_RANK_ADMIN, USER_RANK_FACILITATOR } from 'components/permissions/types';
import { ADMIN_PATHS } from 'components/routers/constants';
export var generatePathWithParams = function (templatePath, params) {
    if (params === void 0) { params = {}; }
    var path = templatePath;
    Object.keys(params).forEach(function (key) {
        path = path.replace(":".concat(key), params[key]);
    });
    return path;
};
function NavigationSetter() {
    var nav = useNavigate();
    useEffect(function () { setNavigate(nav); }, [nav]);
    return null;
}
var AppRouter = function (_a) {
    var rank = _a.rank;
    var isManagerRank = [USER_RANK_ADMIN, USER_RANK_FACILITATOR].includes(rank);
    return (React.createElement(BrowserRouter, { future: { v7_startTransition: true, v7_relativeSplatPath: true } },
        React.createElement(NavigationSetter, null),
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/new-game", element: React.createElement(ViewFacilitatorNewGame, null) }),
            React.createElement(Route, { path: "/token", element: React.createElement(ViewTokenAuthentication, null) }),
            React.createElement(Route, { path: "/api/:token", element: React.createElement(ViewApiAuthentication, null) }),
            React.createElement(Route, { path: "/login/:token/game/:gameToken", element: React.createElement(ViewApiAuthentication, null) }),
            React.createElement(Route, { path: "/login/:token", element: React.createElement(ViewApiAuthentication, null) }),
            React.createElement(Route, { path: "/login", element: React.createElement(ViewLogin, null) }),
            React.createElement(Route, { path: "/join/:gameToken", element: React.createElement(ViewURLAuthentication, null) }),
            React.createElement(Route, { path: "/facilitatorjoin/:pathing/:gameToken", element: React.createElement(ViewURLAuthentication, null) }),
            React.createElement(Route, { path: "/games", element: React.createElement(AuthRoute, { isAuthenticated: isManagerRank },
                    React.createElement(ViewGames, null)) }),
            React.createElement(Route, { path: ADMIN_PATHS.TEMPLATE_TASK, element: React.createElement(AuthRoute, { isAuthenticated: isManagerRank },
                    React.createElement(ViewSingleTemplateTaskEdit, null)) }),
            React.createElement(Route, { path: "/admin/templates/:id", element: React.createElement(AuthRoute, { isAuthenticated: isManagerRank },
                    React.createElement(ViewSingleTemplate, null)) }),
            React.createElement(Route, { path: "/admin/templates", element: React.createElement(AuthRoute, { isAuthenticated: isManagerRank },
                    React.createElement(ViewTemplateListing, null)) }),
            React.createElement(Route, { path: "/admin/users", element: React.createElement(AuthRoute, { isAuthenticated: isManagerRank },
                    React.createElement(ViewAdminUsers, null)) }),
            React.createElement(Route, { path: "/admin", element: React.createElement(AuthRoute, { isAuthenticated: isManagerRank },
                    React.createElement(ViewAdminDashboard, null)) }),
            React.createElement(Route, { path: "/*", element: React.createElement(WrapperItems, null) }))));
};
export default AppRouter;
